import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
  EmailMessageModel,
} from "@jugl-web/rest-api";
import { environment } from "@web-src/environments/environment";

const getAttachmentType = (mimeType: string): ChatMessageAttachmentType => {
  if (mimeType.startsWith("image/")) return ChatMessageAttachmentType.image;
  if (mimeType.startsWith("video/")) return ChatMessageAttachmentType.video;
  if (mimeType.startsWith("audio/")) return ChatMessageAttachmentType.audio;
  return ChatMessageAttachmentType.doc;
};

export const emailMessageToAttachmentsPayload = ({
  message,
  entityId,
}: {
  message: EmailMessageModel;
  entityId: string;
}): ChatMessagePayloadAttachment[] | null => {
  const { attachments } = message.payload;

  if (!attachments?.length) {
    return null;
  }

  return attachments.map((attachment) => ({
    type: getAttachmentType(attachment.mime_type),
    uid: attachment.media_id,
    name: attachment.filename,
    mimetype: attachment.mime_type,
    size: attachment.size,
    url: `${environment.apiUrl}/api/${entityId}/agents/email/media?id=${attachment.media_id}`,
  }));
};
